// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import LectureLessonListPagingResultModel from '../../model/lecture-lesson-list-paging-result-model';
import LectureLessonListPagingResultDTO from '../dto/lecture-lesson-list-paging-result-dto';
import dtoSchema from '../schemas/lecture-lesson-list-paging-result-schema';
import LectureLessonListModel from '../../model/lecture-lesson-list-model';
import ResourceLinkModel from '../../model/resource-link-model';
import PaginationDataModel from '../../model/pagination-data-model';

export default abstract class LectureLessonListPagingResultModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<LectureLessonListPagingResultDTO>) {
    super();
    if (data) {
      this.items = data.items?.map((i) => LectureLessonListModel.toModel(i)) ?? [];
      this.links = data.links?.map((i) => ResourceLinkModel.toModel(i)) ?? [];
      this.paginationData = data.paginationData ? PaginationDataModel.toModel(data.paginationData) : undefined;
    }
  }
  /**
  */
  items?: LectureLessonListModel[];
  /**
  */
  links?: ResourceLinkModel[];
  /**
  */
  paginationData?: PaginationDataModel;

  static toModel(dto: DeepPartial<LectureLessonListPagingResultDTO>): LectureLessonListPagingResultModel;
  static toModel(dto: DeepPartial<LectureLessonListPagingResultDTO> | undefined | null): LectureLessonListPagingResultModel | undefined;
  static toModel(dto: DeepPartial<LectureLessonListPagingResultDTO> | undefined | null): LectureLessonListPagingResultModel | undefined {
    return dto ? new LectureLessonListPagingResultModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<LectureLessonListPagingResultModel> | LectureLessonListPagingResultModel): LectureLessonListPagingResultDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      items: unwrapped.items,
      links: unwrapped.links,
      paginationData: unwrapped.paginationData,
    } as LectureLessonListPagingResultDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for LectureLessonListPagingResultModel, can not map to LectureLessonListPagingResultDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
